module.exports = __webpack_public_path__ + "img/bg3-blur.a27267d.jpg";